/* Jack Andrews pages: color swatches on cards, shop-the-look hotspots, and the header-font test.
   Loaded by snippets/ja-styles.liquid. No dependencies. */
(function () {
  'use strict';
  /* Every ja-* section renders the script tag, so run once per page. */
  if (window.__jaPageScript) return;
  window.__jaPageScript = true;

  /* 1. Swatches (snippets/ja-card.liquid). Each swatch carries its sibling product's data;
        choosing one swaps the card's link, images, color line and price in place. */
  function applySwatch(btn) {
    var root = btn.closest('[data-ja-swatch-root]');
    if (!root) return;
    var d = btn.dataset;
    root.querySelectorAll('[data-ja-link]').forEach(function (a) { a.href = d.url; });
    root.querySelectorAll('[data-ja-img-main], .bjh-card__img:not(.ja-card__alt)').forEach(function (img) { if (d.img) { img.src = d.img; img.removeAttribute('srcset'); img.alt = d.alt || ''; } });
    root.querySelectorAll('[data-ja-img-alt], .ja-card__alt').forEach(function (img) {
      if (d.alt2) { img.src = d.alt2; img.removeAttribute('srcset'); img.hidden = false; } else { img.hidden = true; }
    });
    root.querySelectorAll('[data-ja-img-studio]').forEach(function (img) { if (d.img) { img.src = d.img; img.removeAttribute('srcset'); } });
    root.querySelectorAll('[data-ja-color]').forEach(function (el) { el.textContent = d.color || ''; });
    if (d.price) root.querySelectorAll('[data-ja-price]').forEach(function (el) { el.innerHTML = d.price; });
    root.querySelectorAll('.ja-swatch').forEach(function (b) { b.setAttribute('aria-pressed', b === btn ? 'true' : 'false'); });
    root.classList.add('is-swatched');
  }
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('.ja-swatch');
    if (btn) { e.preventDefault(); applySwatch(btn); }
  });
  document.addEventListener('mouseover', function (e) {
    var btn = e.target.closest && e.target.closest('.ja-swatch');
    if (btn && window.matchMedia('(hover: hover)').matches) applySwatch(btn);
  });

  /* 2. Shop the look (sections/ja-look.liquid): a hotspot and its list row highlight together. */
  function lookActivate(root, n) {
    root.querySelectorAll('[data-ja-look]').forEach(function (el) {
      el.classList.toggle('is-active', el.getAttribute('data-ja-look') === n);
    });
  }
  document.addEventListener('mouseover', function (e) {
    var el = e.target.closest && e.target.closest('[data-ja-look]');
    if (el) lookActivate(el.closest('.ja-look'), el.getAttribute('data-ja-look'));
  });
  document.addEventListener('click', function (e) {
    var spot = e.target.closest && e.target.closest('.ja-look__spot');
    if (!spot) return;
    var root = spot.closest('.ja-look');
    var n = spot.getAttribute('data-ja-look');
    lookActivate(root, n);
    var row = root.querySelector('.ja-look__item[data-ja-look="' + n + '"]');
    if (row) { row.focus({ preventScroll: true }); if (window.innerWidth < 990) row.scrollIntoView({ behavior: 'smooth', block: 'center' }); }
  });

  /* 2a. Tabs (sections/ja-look.liquid destinations) */
  document.addEventListener('click', function (e) {
    var tab = e.target.closest && e.target.closest('[data-ja-tab]');
    if (!tab) return;
    var root = tab.closest('[data-ja-tabs]');
    var i = tab.getAttribute('data-ja-tab');
    root.querySelectorAll('[data-ja-tab]').forEach(function (t) { t.setAttribute('aria-selected', t === tab ? 'true' : 'false'); });
    root.querySelectorAll('[data-ja-panel]').forEach(function (p) { p.hidden = p.getAttribute('data-ja-panel') !== i; });
  });

  /* 2c. Travel set (sections/ja-travel.liquid): color toggle, running total, add the set to cart */
  function money(cents) {
    if (window.Shopify && typeof Shopify.formatMoney === 'function') {
      try { return Shopify.formatMoney(cents); } catch (e) {}
    }
    return '$' + (cents / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }
  function setRefresh(root) {
    var color = root.getAttribute('data-ja-color');
    var count = 0, total = 0;
    root.querySelectorAll('[data-ja-set-tile]').forEach(function (tile) {
      var on = tile.getAttribute('data-ja-set-tile') === color;
      tile.hidden = !on;
      var box = tile.querySelector('.ja-travel__check');
      if (on && box.checked && !box.disabled) { count++; total += parseInt(box.dataset.price, 10) || 0; }
    });
    root.querySelector('[data-ja-set-count]').textContent = count + (count === 1 ? ' piece' : ' pieces');
    root.querySelector('[data-ja-set-total]').textContent = money(total);
    root.querySelector('[data-ja-set-add]').disabled = count === 0;
  }
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-ja-set-color]');
    if (!btn) return;
    var root = btn.closest('[data-ja-set]');
    root.setAttribute('data-ja-color', btn.getAttribute('data-ja-set-color'));
    root.querySelectorAll('[data-ja-set-color]').forEach(function (b) { var on = b === btn; b.setAttribute('aria-checked', on ? 'true' : 'false'); b.setAttribute('aria-pressed', on ? 'true' : 'false'); });
    var nm = root.querySelector('[data-ja-set-colorname]'); if (nm) nm.textContent = btn.getAttribute('data-label') || '';
    setRefresh(root);
  });
  document.addEventListener('change', function (e) {
    if (e.target.classList && e.target.classList.contains('ja-travel__check')) setRefresh(e.target.closest('[data-ja-set]'));
  });
  document.addEventListener('click', function (e) {
    var add = e.target.closest && e.target.closest('[data-ja-set-add]');
    if (!add) return;
    var root = add.closest('[data-ja-set]');
    var color = root.getAttribute('data-ja-color');
    var items = [];
    root.querySelectorAll('[data-ja-set-tile="' + color + '"] .ja-travel__check').forEach(function (box) {
      if (box.checked && !box.disabled) items.push({ id: parseInt(box.value, 10), quantity: 1 });
    });
    if (!items.length) return;
    var msg = root.querySelector('[data-ja-set-msg]');
    add.disabled = true; msg.textContent = 'Adding…';
    fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: items }) })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); })
      .then(function () { msg.textContent = 'Added. Taking you to your cart…'; window.location.href = '/cart'; })
      .catch(function (err) { add.disabled = false; msg.textContent = (err && err.description) || 'Something went wrong. Please add the pieces one at a time.'; });
  });
  function setInit() { document.querySelectorAll('[data-ja-set]').forEach(setRefresh); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', setInit); else setInit();


  /* 2d. Reviews slider (sections/ja-quotes.liquid): one review at a time with a large photo.
         Pulls the newest 5-star reviews for the listed products from Yotpo's public widget API,
         then swaps them in; the section's own fallback reviews stay if that fails. */
  function esc(t) { var d = document.createElement('div'); d.textContent = t == null ? '' : String(t); return d.innerHTML; }
  function pad(n) { return (n < 10 ? '0' : '') + n; }
  function reviewsInit(root) {
    var state = { i: 0, n: 0, timer: null, paused: false };
    var slidesEl = root.querySelector('[data-ja-reviews-slides]');
    var mediaEl = root.querySelector('[data-ja-reviews-media]');
    var countEl = root.querySelector('[data-ja-reviews-count]');
    var bar = root.querySelector('[data-ja-reviews-bar]');
    var DELAY = 8000;
    function show(i) {
      var slides = slidesEl.querySelectorAll('[data-ja-slide]');
      var imgs = mediaEl.querySelectorAll('[data-ja-slide-img]');
      state.n = slides.length;
      if (!state.n) return;
      state.i = (i + state.n) % state.n;
      slides.forEach(function (el, k) { el.classList.toggle('is-active', k === state.i); el.setAttribute('aria-hidden', k === state.i ? 'false' : 'true'); });
      imgs.forEach(function (el, k) { el.classList.toggle('is-active', k === state.i); });
      countEl.textContent = pad(state.i + 1) + ' / ' + pad(state.n);
      if (bar) { bar.style.transition = 'none'; bar.style.width = '0%'; void bar.offsetWidth; if (!state.paused) { bar.style.transition = 'width ' + DELAY + 'ms linear'; bar.style.width = '100%'; } }
      schedule();
    }
    function schedule() {
      clearTimeout(state.timer);
      if (state.paused || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      state.timer = setTimeout(function () { show(state.i + 1); }, DELAY);
    }
    root.querySelector('[data-ja-reviews-prev]').addEventListener('click', function () { show(state.i - 1); });
    root.querySelector('[data-ja-reviews-next]').addEventListener('click', function () { show(state.i + 1); });
    root.addEventListener('mouseenter', function () { state.paused = true; clearTimeout(state.timer); if (bar) { bar.style.transition = 'none'; } });
    root.addEventListener('mouseleave', function () { state.paused = false; show(state.i); });
    root.addEventListener('focusin', function () { state.paused = true; clearTimeout(state.timer); });
    var x0 = null;
    root.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
    root.addEventListener('touchend', function (e) { if (x0 === null) return; var dx = e.changedTouches[0].clientX - x0; if (Math.abs(dx) > 40) show(state.i + (dx < 0 ? 1 : -1)); x0 = null; });
    show(0);

    if (root.getAttribute('data-dynamic') !== 'true') return; /* static: the review blocks as they are */
    var key = root.getAttribute('data-yotpo-key');
    var max = parseInt(root.getAttribute('data-max'), 10) || 8;
    var minLen = parseInt(root.getAttribute('data-min-length'), 10) || 70;
    var products = [];
    try { products = JSON.parse(root.querySelector('[data-ja-reviews-products]').textContent); } catch (e) {}
    if (!key || !products.length || !window.fetch) return;
    Promise.all(products.map(function (p) {
      return fetch('https://api-cdn.yotpo.com/v1/widget/' + key + '/products/' + p.id + '/reviews.json?per_page=20&page=1&sort=date&direction=desc')
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (j) { return ((j && j.response && j.response.reviews) || []).map(function (rv) { return { rv: rv, p: p }; }); })
        .catch(function () { return []; });
    })).then(function (lists) {
      var seen = {};
      var all = [].concat.apply([], lists).filter(function (x) {
        var t = (x.rv.content || '').trim();
        if (x.rv.score !== 5 || t.length < minLen || seen[x.rv.id]) return false;
        seen[x.rv.id] = true; return true;
      });
      all.sort(function (a, b) { return new Date(b.rv.created_at) - new Date(a.rv.created_at); });
      /* spread across products: take newest from each product in turn */
      var byP = {}; all.forEach(function (x) { (byP[x.p.id] = byP[x.p.id] || []).push(x); });
      var picked = [], more = true;
      while (picked.length < max && more) {
        more = false;
        products.forEach(function (p) { var q = byP[p.id]; if (q && q.length && picked.length < max) { picked.push(q.shift()); more = true; } });
      }
      if (picked.length < 3) return;
      slidesEl.innerHTML = picked.map(function (x, k) {
        var name = (x.rv.user && x.rv.user.display_name) || 'Verified buyer';
        var label = x.p.title + (x.p.color ? ', ' + x.p.color : '');
        var body = x.rv.content.trim(); if (body.length > 420) body = body.slice(0, 400).replace(/\s+\S*$/, '') + '…';
        return '<figure class="ja-review" data-ja-slide="' + k + '" role="group" aria-roledescription="slide" aria-label="' + (k + 1) + ' of ' + picked.length + '">' +
          '<span class="bjh-stars ja-review__stars" style="--bjh-fill: 100%;" aria-hidden="true"></span><span class="bjh-vh">Rated 5 out of 5</span>' +
          (x.rv.title && x.rv.title.trim() && body.indexOf(x.rv.title.trim()) !== 0 ? '<p class="ja-review__title">' + esc(x.rv.title.trim()) + '</p>' : '') +
          '<blockquote class="ja-review__quote">' + esc(body) + '</blockquote>' +
          '<figcaption class="ja-review__by"><span class="ja-review__name">' + esc(name) + (x.rv.verified_buyer ? ' <small>Verified buyer</small>' : '') + '</span>' +
          '<a class="ja-review__product" href="' + esc(x.p.url) + '"><img src="' + esc(x.p.thumb) + '" alt=""' + (k < 2 ? '' : ' loading="lazy"') + '><span>' + esc(label) + '</span></a></figcaption></figure>';
      }).join('');
      mediaEl.innerHTML = picked.map(function (x, k) {
        return '<div class="ja-reviews__img' + (x.p.life ? ' ja-reviews__img--life' : '') + '" data-ja-slide-img="' + k + '"><img src="' + esc(x.p.img) + '" alt=""' + (k < 2 ? '' : ' loading="lazy"') + '></div>';
      }).join('');
      root.classList.add('is-live');
      show(0);
    });
  }
  function reviewsBoot() { document.querySelectorAll('[data-ja-reviews]').forEach(reviewsInit); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', reviewsBoot); else reviewsBoot();


  /* 2e. Quick view (buttons with data-ja-quick="<handle>"): a pop-up with the product's photos,
         price, short description, size choice when it has one, and Add to Cart. */
  var qv = null;
  function qvClose() { if (!qv) return; qv.hidden = true; document.documentElement.style.overflow = ''; if (qv._back) qv._back.focus(); }
  function qvOpen(handle, back) {
    if (!qv) {
      qv = document.createElement('div');
      qv.className = 'bjh ja ja-qv'; qv.hidden = true;
      qv.innerHTML = '<div class="ja-qv__scrim" data-ja-qv-close></div><div class="ja-qv__panel" role="dialog" aria-modal="true" aria-labelledby="ja-qv-title"><button type="button" class="ja-qv__close" data-ja-qv-close aria-label="Close">&times;</button><div class="ja-qv__body"></div></div>';
      document.body.appendChild(qv);
      qv.addEventListener('click', function (e) { if (e.target.closest('[data-ja-qv-close]')) qvClose(); });
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && qv && !qv.hidden) qvClose(); });
    }
    qv._back = back;
    var body = qv.querySelector('.ja-qv__body');
    body.innerHTML = '<p class="ja-qv__loading">Loading…</p>';
    qv.hidden = false; document.documentElement.style.overflow = 'hidden';
    qv.querySelector('.ja-qv__close').focus();
    fetch('/products/' + encodeURIComponent(handle) + '.js').then(function (r) { return r.json(); }).then(function (p) {
      var name = p.title.split(' | ')[0].replace(/^Limited Edition /, ''), color = p.title.indexOf(' | ') > -1 ? p.title.split(' | ').pop() : '';
      var imgs = (p.images || []).slice(0, 5);
      var multi = p.variants.length > 1;
      var desc = (p.description || '').replace(/<[^>]+>/g, ' ').replace(/\s+/g, ' ').trim();
      if (desc.length > 320) desc = desc.slice(0, 300).replace(/\s+\S*$/, '') + '…';
      body.innerHTML =
        '<div class="ja-qv__gallery"><img class="ja-qv__main" src="' + esc(imgs[0] ? imgs[0] + (imgs[0].indexOf('?') > -1 ? '&' : '?') + 'width=1000' : '') + '" alt="' + esc(name) + '">' +
        '<div class="ja-qv__thumbs">' + imgs.map(function (u, k) { return '<button type="button" class="ja-qv__thumb' + (k ? '' : ' is-active') + '" data-src="' + esc(u + (u.indexOf('?') > -1 ? '&' : '?') + 'width=1000') + '"><img src="' + esc(u + (u.indexOf('?') > -1 ? '&' : '?') + 'width=160') + '" alt=""></button>'; }).join('') + '</div></div>' +
        '<div class="ja-qv__info">' + (color ? '<p class="ja-card__color">' + esc(color) + '</p>' : '') +
        '<h2 class="ja-display ja-qv__title" id="ja-qv-title">' + esc(name) + '</h2>' +
        '<p class="ja-qv__price">' + money(p.price) + (p.compare_at_price > p.price ? ' <s>' + money(p.compare_at_price) + '</s>' : '') + '</p>' +
        (desc ? '<p class="ja-qv__desc">' + esc(desc) + '</p>' : '') +
        (multi ? '<label class="ja-qv__label" for="ja-qv-variant">' + esc(p.options[0].name || 'Option') + '</label><select id="ja-qv-variant" class="ja-qv__select">' + p.variants.map(function (v) { return '<option value="' + v.id + '"' + (v.available ? '' : ' disabled') + '>' + esc(v.title) + (v.available ? '' : ' (sold out)') + '</option>'; }).join('') + '</select>' : '') +
        '<button type="button" class="bjh-btn ja-qv__add"' + (p.available ? '' : ' disabled') + '>' + (p.available ? 'Add to cart' : 'Sold out') + '</button>' +
        '<p class="ja-qv__msg" role="status" aria-live="polite"></p>' +
        '<a class="bjh-link ja-qv__more" href="/products/' + esc(p.handle) + '">View full details</a></div>';
      body.querySelectorAll('.ja-qv__thumb').forEach(function (t) { t.addEventListener('click', function () { body.querySelector('.ja-qv__main').src = t.dataset.src; body.querySelectorAll('.ja-qv__thumb').forEach(function (x) { x.classList.toggle('is-active', x === t); }); }); });
      var add = body.querySelector('.ja-qv__add');
      add.addEventListener('click', function () {
        var sel = body.querySelector('#ja-qv-variant');
        var id = sel ? parseInt(sel.value, 10) : (p.variants.filter(function (v) { return v.available; })[0] || p.variants[0]).id;
        var msg = body.querySelector('.ja-qv__msg'); add.disabled = true; msg.textContent = 'Adding…';
        fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: [{ id: id, quantity: 1 }] }) })
          .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); })
          .then(function () { msg.innerHTML = 'Added to your cart. <a href="/cart">View cart</a>'; add.disabled = false; })
          .catch(function (err) { add.disabled = false; msg.textContent = (err && err.description) || 'Something went wrong. Please try again.'; });
      });
    }).catch(function () { body.innerHTML = '<p class="ja-qv__loading">Couldn\'t load this piece. <a href="/products/' + esc(handle) + '">Open it</a> instead.</p>'; });
  }
  /* Complete the Look (snippets/ja-pdp, part: complete): one-variant pieces go straight into the cart */
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-ja-add]');
    if (!b) return;
    e.preventDefault();
    var label = b.textContent; b.disabled = true; b.textContent = 'Adding…';
    fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: [{ id: parseInt(b.getAttribute('data-ja-add'), 10), quantity: 1 }] }) })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); })
      .then(function () {
        b.textContent = 'Added'; b.disabled = false;
        var m = b.parentNode.querySelector('.ja-ctl__msg');
        if (!m) { m = document.createElement('p'); m.className = 'ja-ctl__msg'; m.setAttribute('role', 'status'); b.parentNode.appendChild(m); }
        m.innerHTML = '<a href="/cart">View cart</a>';
        setTimeout(function () { b.textContent = label; }, 2500);
      })
      .catch(function (err) { b.disabled = false; b.textContent = label; alertless(b, (err && err.description) || 'Couldn\'t add it. Please try again.'); });
  });
  function alertless(b, text) {
    var m = b.parentNode.querySelector('.ja-ctl__msg');
    if (!m) { m = document.createElement('p'); m.className = 'ja-ctl__msg'; m.setAttribute('role', 'status'); b.parentNode.appendChild(m); }
    m.textContent = text;
  }
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-ja-quick]');
    if (!b) return;
    e.preventDefault(); e.stopPropagation();
    qvOpen(b.getAttribute('data-ja-quick'), b);
  }, true);

  /* 2b. Category explorer (sections/ja-categories.liquid): hovering or focusing a name shows its
         photo; a click follows the link as usual. */
  function exploreShow(item) {
    var root = item.closest('[data-ja-explore]');
    var i = item.getAttribute('data-ja-explore-item');
    root.querySelectorAll('[data-ja-explore-item]').forEach(function (el) { el.classList.toggle('is-active', el === item); });
    var side = item.closest('.ja-explore__side'); if (side) side.classList.add('is-hover'); /* the faint photo only shows while a name is hovered (Kate, Oct 20) */
    root.querySelectorAll('[data-ja-explore-bg]').forEach(function (el) { el.classList.toggle('is-active', el.getAttribute('data-ja-explore-bg') === i); });
    root.querySelectorAll('[data-ja-explore-panel]').forEach(function (el) {
      var on = el.getAttribute('data-ja-explore-panel') === i;
      el.classList.toggle('is-active', on);
      el.setAttribute('aria-hidden', on ? 'false' : 'true');
    });
  }
  document.addEventListener('mouseover', function (e) {
    var item = e.target.closest && e.target.closest('[data-ja-explore-item]');
    if (item) exploreShow(item);
  });
  document.addEventListener('focusin', function (e) {
    var item = e.target.closest && e.target.closest('[data-ja-explore-item]');
    if (item) exploreShow(item);
  });
  function exploreOff(e) {
    var list = e.target.closest && e.target.closest('.ja-explore__list');
    if (!list) return;
    var to = e.relatedTarget;
    if (to && list.contains(to)) return;
    var side = list.closest('.ja-explore__side'); if (side) side.classList.remove('is-hover');
  }
  document.addEventListener('mouseout', exploreOff);
  document.addEventListener('focusout', exploreOff);

  /* Parallax: the blurred texture under Heirloom Pieces drifts slower than the page (Kate, Oct 20) */
  (function () {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    var items = [], ticking = false;
    function update() {
      ticking = false;
      var vh = window.innerHeight;
      items.forEach(function (el) {
        var r = el.parentNode.getBoundingClientRect();
        if (r.bottom < 0 || r.top > vh) return;
        var off = (r.top + r.height / 2 - vh / 2) * -0.15; /* 0 when the band is centred on screen */
        off = Math.max(-130, Math.min(130, off));
        el.style.transform = 'translate3d(0,' + off.toFixed(1) + 'px,0)';
      });
    }
    function ask() { if (!ticking) { ticking = true; requestAnimationFrame(update); } }
    function boot() {
      items = [].slice.call(document.querySelectorAll('.ja-promise__bgimg, [data-ja-parallax]')); /* [data-ja-parallax]: the JA product page's care band photo */
      if (!items.length) return;
      window.addEventListener('scroll', ask, { passive: true });
      window.addEventListener('resize', ask);
      update();
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  })();

  /* 3. (The header-font test picker was removed again Oct 21: Kate is set on Cinzel Decorative + Cinzel.) */
  try { localStorage.removeItem('jafont3'); } catch (e) {}
  /* Promise colors on preview links only: ?promise=gold|navy|brown|maroon|band (Kate, Oct 20) */
  (function () {
    var role = window.Shopify && Shopify.theme && Shopify.theme.role;
    var want = new URLSearchParams(location.search).get('promise');
    if (!want || !role || role === 'main') return;
    function go() {
      document.querySelectorAll('.ja-promise').forEach(function (s) {
        s.className = s.className.replace(/ja-promise--\w+/, 'ja-promise--' + want).replace(/ja-bg--\w+/, want === 'band' ? 'ja-bg--navy' : 'ja-bg--sand');
      });
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', go); else go();
  })();
  /* Window light (snippets/ja-light): back-to-back ja-light sections share one light layer. Each section's
     layer is sized to the whole run and shifted up by the section's offset, so the slats line up across them. */
  (function () {
    function size() {
      var secs = [].slice.call(document.querySelectorAll('.ja-light'));
      var runs = [];
      secs.forEach(function (s) {
        var wrap = s.closest('.shopify-section') || s;
        var last = runs.length && runs[runs.length - 1];
        var prevWrap = last && (last[last.length - 1].closest('.shopify-section') || last[last.length - 1]);
        /* sections hidden at this width (the phone/tablet ja-panels tiles on desktop, Oct 26) don't break the run */
        var next = prevWrap && prevWrap.nextElementSibling;
        while (next && next !== wrap && next.offsetHeight === 0) next = next.nextElementSibling;
        if (prevWrap && next === wrap) last.push(s); else runs.push([s]);
      });
      runs.forEach(function (run) {
        var top = run[0].getBoundingClientRect().top;
        var h = run[run.length - 1].getBoundingClientRect().bottom - top;
        run.forEach(function (s) {
          s.style.setProperty('--ja-light-top', (top - s.getBoundingClientRect().top) + 'px');
          s.style.setProperty('--ja-light-h', h + 'px');
        });
      });
    }
    function start() {
      if (!document.querySelector('.ja-light')) return;
      size();
      window.addEventListener('resize', size);
      window.addEventListener('load', size);
      if (window.ResizeObserver) { var ro = new ResizeObserver(size); document.querySelectorAll('.ja-light').forEach(function (s) { ro.observe(s); }); }
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
  })();

  /* 4. No interlocked OO or HE (Kate, Oct 21). Cinzel Decorative's kerning tucks a double o, and an h into
        a following e, into one linked shape. In text set in Cinzel Decorative, the second letter of each
        such pair goes in a span with kerning off, so the pair sits apart while the rest of the word keeps
        its kerning. The text itself is
        unchanged (search and screen readers read it as normal); late content (reviews, Recently viewed)
        is caught as it arrives. */
  (function () {
    var PAIR = /[Oo][Oo]|[Hh][Ee]/;
    function joined(a, b) { return PAIR.test(a + b); }
    function deco(el) { return el && /Cinzel Decorative/i.test(getComputedStyle(el).fontFamily); }
    function fix(root) {
      if (!root || !document.body) return;
      var w = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, {
        acceptNode: function (n) { return PAIR.test(n.nodeValue) ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_REJECT; }
      });
      var hits = [], n;
      while ((n = w.nextNode())) hits.push(n);
      hits.forEach(function (t) {
        var p = t.parentElement;
        if (!p || /^(SCRIPT|STYLE|TEXTAREA|INPUT|OPTION)$/.test(p.tagName) || !deco(p)) return;
        var v = t.nodeValue, frag = document.createDocumentFragment(), from = 0;
        for (var i = 1; i < v.length; i++) {
          if (joined(v[i - 1], v[i])) {
            frag.appendChild(document.createTextNode(v.slice(from, i)));
            var sp = document.createElement('span');
            sp.className = 'ja-oo';
            sp.style.fontKerning = 'none';
            sp.textContent = v[i];
            frag.appendChild(sp);
            from = i + 1;
          }
        }
        frag.appendChild(document.createTextNode(v.slice(from)));
        p.replaceChild(frag, t);
      });
    }
    function start() {
      fix(document.body);
      if (document.fonts && document.fonts.ready) document.fonts.ready.then(function () { fix(document.body); });
      if (window.MutationObserver) {
        var queued = false;
        new MutationObserver(function () {
          if (queued) return;
          queued = true;
          requestAnimationFrame(function () { queued = false; fix(document.body); });
        }).observe(document.body, { childList: true, subtree: true });
      }
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
  })();
})();
